<template>
  <div class="main-image-upload">
    <p
      v-if="title"
      class="main-image-upload_title"
    >
      {{ $t(title) }}
    </p>
    <div
      class="main-image"
      :style="{backgroundImage: 'url(' + _image + ')' }"
      :class="{blue:blue}"
    >
      <div
        v-if="isloading"
        class="load-wrap"
      >
        <div class="progress-item">
          <i
            class="icon-close"
            @click="deleteImage()"
          />
          <div class="progress">
            <ReloadCircleProgress :range="percent" />
          </div>
        </div>
        <div class="bg" />
      </div>
      <div
        v-else
        class="change-button-wrap"
      >
        <UploadImageButton
          v-model="uploadImagefile"
          arc-button
          :upload-url="uploadUrl"
          :factory="factory"
          @input="fileChange()"
        />
        <i
          class="cancel icon-cancel"
          @click="deleteImage()"
        />
        <div class="bg" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MainImageUpload",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    image: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
    edit: {
      type: Boolean,
      default: false,
    },
    isloading: {
      type: Boolean,
      default: false,
    },
    tabletNarrow: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    percent: {
      type: Number,
      default: 0,
    },
    factory: {
      type: String,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    previewActive: false,
    uploadImagefile: [],
    range: 0,
  }),
  computed: {
    _image() {
      if (this.isloading) {
        return this.previewUrl;
      } else {
        return this.image;
      }
    },
  },
  methods: {
    previewOpen() {
      this.previewActive = true;
      this.$emit("input", true);
    },
    previewClose() {
      this.previewActive = false;
      this.$emit("input", false);
    },
    fileChange() {
      this.$emit("input", this.uploadImagefile);
    },
    deleteImage() {
      this.uploadImagefile = "";
      this.fileChange();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/main-image-upload";
</style>